<template>
  <div>
    <el-form ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="ID">
        <el-input
          v-model="target_id"
          :disabled="true"
          style="width: 60%;"
        ></el-input>
      </el-form-item>
      <el-form-item label="标题">
        <el-input
          v-model="target_info.title"
          :disabled="true"
          style="width: 60%;"
        ></el-input>
      </el-form-item>
      <el-form-item v-if="column_type == 'image'" label="原始图片">
        <img :src="target_info.original_data" class="avatar" />
      </el-form-item>
      <el-form-item v-if="column_type == 'image'" label="活动图片">
        <el-upload
          class="avatar-uploader"
          :action="ossAction"
          :show-file-list="false"
          :http-request="uploadOSSRequest"
          :before-upload="beforeImageUpload"
        >
          <img v-if="object_data" :src="object_data" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          <div slot="tip" class="el-upload__tip">
            尺寸750*560 px，大小不超过100K
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item label="活动展示时间">
        <el-date-picker
          class="search-el"
          size="mini"
          v-model="date_timestamp"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetimerange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="截止日期"
          :default-time="['00:00:00', '23:59:59']"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button
          size="mini"
          type="primary"
          @click="setColumnData()"
          :loading="updateLoading"
          :disabled="isshow ? true: false"
          >确 定</el-button
        >
      </el-form-item>
    </el-form>

    <div class="hides" v-if="isshow">
      <i style="margin-top: 20px; font-size: 40px" class="el-icon-loading"> </i
      ><br />
      正在上传
    </div>
  </div>
</template>

<script>
import {
  beforeImageUpload,
  uploadOSSRequest,
  getAliyunOssToken,
} from "@/api/common";

import { getTargetInfo, setColumnData } from "@/api/common";

export default {
  data: function () {
    return {
      target_type: this.$route.query.target_type,
      target_id: this.$route.query.target_id,
      column_name: this.$route.query.column_name,
      column_type: this.$route.query.column_type,
      object_data: "",
      date_timestamp: [],

      isshow: false,
      ossAction: "",
      ossData: {},
      loading: false,
      aliyunOssToken: "",

      target_info: {
        title: "",
        original_data: "",
      },
      updateLoading: false,
    };
  },
  created: function () {
    this.getInfo();
  },
  methods: {
    beforeImageUpload(file) {
        this.isshow = true;
      beforeImageUpload(file);
    },
    uploadOSSRequest(file) {
      getAliyunOssToken({ dir: "" }).then((res) => {
        uploadOSSRequest(file.file, res.data).then((fileUrl) => {
          this.object_data = fileUrl;
          this.isshow = false;
        });
      });
    },

    setColumnData() {
      setColumnData({
        target_id: this.target_id,
        target_type: this.target_type,
        column_name: this.column_name,
        object_data: this.object_data,
        date_timestamp: this.date_timestamp,
      }).then((response) => {
        if (response.status == 2000) {
          this.$message({
            showClose: true,
            message: "设置成功",
            type: "success",
          });
          this.updateLoading = false;
          this.getInfo();
        }
      });
    },

    getInfo() {
      getTargetInfo({
        target_id: this.target_id,
        target_type: this.target_type,
        column_name: this.column_name,
      }).then((response) => {
        this.target_info = {
          title: response.data.target_info.title,
          original_data: response.data.target_info.original_data,
        };
        if (response.data.data != null) {
          this.object_data = response.data.data.object_data;
          this.date_timestamp = [
            response.data.data.begin_at,
            response.data.data.end_at,
          ];
        }
        this.loading = false;
      });
    },
  },
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 112px;
  line-height: 150px;
  text-align: center;
}
.avatar {
  width: 150px;
  height: 112px;
  display: block;
  background: #d8d8d8;
  border-radius: 6px;
}
.hides {
  background: #fff;
  width: 100px;
  height: 100px;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
}
</style>
